import {observer} from "mobx-react";
import {ModalDialog} from "../../../ui";
import {DialogAction} from "@kroschke/react-ui";
import "./ScanDocumentDialog.scss"
import {ScanConfigurationView} from "./ScanConfigurationView";
import {ScanDocumentView} from "./ScanDocumentView";
import {ScanDocumentDialogStore} from "../../../../store";


interface ScanDocumentDialogProps {
    store: ScanDocumentDialogStore
}


const ScanDocumentDialog = observer(function ScanDocumentDialog({
                                                                    store
                                                                }: ScanDocumentDialogProps) {

    const dialogActions: DialogAction[] = [
        {
            label: "Abbrechen",
            execute: async function () {
                store.dialogOpen = false
                store.reset()
            },
            className: 'is-rounded is-small'
        }
    ]

    if (!store.configurationDone) {
        dialogActions.push({
            label: 'Scan starten',
            executing: store.executing,
            disabled: !store.isCurrentOk,
            execute: async function () {
                store.executing = true
                await store.next()
                store.executing = false
            },
            className: 'is-primary is-rounded is-small'
        })
    } else {
        dialogActions.push({
            label: 'Speichern & nächstes Dokument',
            executing: store.executing,
            disabled: !store.isCurrentOk,
            execute: async function () {
                store.executing = true
                await store.next()
                store.executing = false
            },
            className: 'is-primary is-rounded is-small'
        })

        if (store.hasReadyToFinish) {
            dialogActions.push({
                label: 'Speichern & Akte fertig',
                executing: store.executing,
                disabled: !store.isCurrentOk,
                execute: async function () {
                    store.executing = true
                    const success: boolean = await store.finish()
                    store.executing = false
                    store.dialogOpen = success
                },
                className: 'is-primary is-rounded is-small'
            })
        }
    }


    return <div className={"scan-document-dialog"}>
        <ModalDialog
            titleCloseable={false}
            store={store}
            actions={dialogActions}
            title={"Fahrzeug Scan erfassen"}
        >
            <div
                onKeyDown={e => {
                if ('Enter' === e.key) {
                    store.next()
                }
            }}>
                {!store.configurationDone && <ScanConfigurationView
                    value={{
                        vin: store.vin,
                        customer: store.customer
                    }}
                    onChange={d => {
                        store.vin = d.vin
                        store.customer = d.customer
                    }}/>}
                {store.configurationDone &&
                    <ScanDocumentView
                        disabled={!Boolean(store.currentDoc?.file)}
                        value={store.currentDoc!}
                        validation={store.validationResult}
                        onBlur={() => store.validate()}
                        onChange={d => store.updateCurrentDoc(d)}
                    />}
            </div>
        </ModalDialog>
    </div>
})

export {
    ScanDocumentDialog
}

